import { Text, Stack, HStack, Box, Flex } from '@chakra-ui/react';
import { BaseButton, BasePopover } from '@cks-internal/react-base';
import { faClock, faRightFromBracket, faUserCheck, faUserXmark } from '@fortawesome/free-solid-svg-icons';
import { StatusLine } from '../../features/workflow/components/StatusLine';
import { agentStatusDisplay } from '../../features/workflow/displayTypes';
import { ScoreButtons } from '../../features/workflow/ScoreButtons';
import { UserType, agentStatusType } from '../../features/workflow/types';
import { useWorkflowSocket } from '../../features/workflow/hub/useWorkflowSocket';
import { useHoursFormat } from '../../features/workflow/utils/formatter';
import { WfAvatar } from '../../features/workflow/components/WfAvatar';
import { wfWigitModes } from '../../features/workflow/CoordinatorWidget';

type Props = {
  user: UserType;
  mode?: wfWigitModes;
  onUserDialog: (user: UserType, x: 'status' | 'schedules') => void;
};
export const ManagedUser = (props: Props) => {
  const invoke = useWorkflowSocket((r) => r.invoke);
  const shiftString = useHoursFormat(props.user?.Shift);
  const lunchString = useHoursFormat(props.user?.Lunch);
  const statusDisplay = agentStatusDisplay[props.user?.Status as agentStatusType];
  return (
    <Flex
      flexDir={'column'}
      w={'fit-content'}
      shadow={'md'}
      borderRadius='md'
      bgColor={statusDisplay?.bgColor}
      p={'8px'}>
      <HStack>
        <Stack flex={'1'} alignSelf={'flex-start'}>
          <HStack w={'100%'}>
            <WfAvatar user={props.user} />

            {props.user && props.user.Id && (
              <BaseButton
                fontSize={'0.7rem'}
                icon={faClock}
                size={'xs'}
                zIndexMenu={'max'}
                onClick={() => {
                  if (props.user) {
                    props.onUserDialog(props.user, 'schedules');
                  }
                }}
                menuItems={[
                  {
                    text: `Set ${props.user?.Name} to ${props.user?.Status != agentStatusType.Away ? 'Away' : 'Read'}`,
                    icon: props.user?.Status != agentStatusType.Away ? faRightFromBracket : faUserCheck,
                    onClick() {
                      if (props.user?.Status != agentStatusType.Away && props.user) {
                        props.onUserDialog(props.user, 'status');
                        return;
                      }
                      if (props.user?.Id) {
                        invoke('UpdateStatus', agentStatusType.Ready, props.user.Id, undefined);
                      }
                    }
                  },
                  {
                    icon: faUserXmark,
                    text: 'Kick',
                    onClick() {
                      if (props.user?.Id) {
                        invoke('Kick', props.user.Id);
                      }
                    }
                  }
                ]}>
                Set schedule
              </BaseButton>
            )}

            <HStack>
              <ScoreButtons
                mode={props.mode}
                user={props.user ?? {}}
                buttonArea={'30px'}
                scoreFontSize={'xs'}
                hideAbbr
              />
            </HStack>
          </HStack>
          <Box
            divideX={'1px'}
            divideColor={'black'}
            display={'flex'}
            w={'100%'}
            gap={'4px'}
            borderTop={'sm'}
            borderBottom={'sm'}
            justifyContent={'space-between'}>
            <HStack w={'100%'} justifyContent={'space-between'}>
              <StatusLine title='Shift' status={`${shiftString.start} - ${shiftString.end}`} />
            </HStack>
            <HStack p={'4px'} w={'100%'} justifyContent={'space-between'}>
              <StatusLine title='Break' status={`${lunchString.start} - ${lunchString.end}`} />
            </HStack>
          </Box>
        </Stack>
      </HStack>
      {props.user?.StatusMessage != undefined ? (
        <BasePopover
          trigger={
            <HStack w={'100%'} pt={'4px'}>
              <StatusLine title='Message' status={`${props.user?.StatusMessage} `} />
            </HStack>
          }>
          <Text>{`${props.user?.StatusMessage}`}</Text>
        </BasePopover>
      ) : (
        <HStack w={'100%'} pt={'4px'}>
          <StatusLine title='Message' status={''} />
        </HStack>
      )}
    </Flex>
  );
};
